export default {
	MANAGE_TAGS: 'manage-tags',
	LIST_TRIGGERS: 'list-triggers',
	PRODUCT_VARIANTS: 'product-variants',
	ORDER_STATUS: 'order-status',
	MODULE_FORM: 'module-form',
	DASHBOARD: 'dashboard',
	DASHBOARD_ANALYTICS: 'dashboard-analytics',
	DEPLOYMENT_SERVERS: 'deployment-servers',
	MARKETING_HELP: 'marketing-help',
};
